module.exports = __webpack_public_path__ + "img/Ithaki.994fc6d9.png";